module.exports = __webpack_public_path__ + "img/zhongshihua.54d86f34.png";